import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GenericDropDownV3, SimpleListAdapter, TS_DropDown, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { FAQTypes } from '@app/advisor-ui-shared';
import { ModuleFE_FAQ } from './ModuleFE_FAQ.js';
import { DBItemDropDownMultiSelector } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { ICONS } from '@app/styles';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
const Props_DropDown = {
    module: ModuleFE_FAQ,
    modules: [ModuleFE_FAQ],
    mapper: item => [item.label],
    placeholder: 'Choose a FAQ',
    renderer: item => _jsxs("div", { className: "ll_h_c", children: [" ", item.label, " "] })
};
export const DropDown_FAQ = GenericDropDownV3.prepare(Props_DropDown);
const Props_MultiSelect = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_FAQ,
    itemRenderer: (item, onDelete, disabled) => {
        return !item ? _jsx(_Fragment, { children: "Not Found" }) : _jsxs(_Fragment, { children: [!disabled && _jsx(ICONS.x.component, { onClick: onDelete }), item.label] });
    },
    uiSelector: DropDown_FAQ.selectable,
});
export const MultiSelect_FAQ = TS_MultiSelect_V2.prepare(Props_MultiSelect);
const mandatoryProps_FAQType = {
    adapter: SimpleListAdapter([...FAQTypes], item => _jsx(_Fragment, { children: item.item })),
    caret: DropDown_DefaultCaret,
    placeholder: 'Select FAQ Type',
};
export const DropDown_FAQType = TS_DropDown.prepare(mandatoryProps_FAQType);
//# sourceMappingURL=ui-components.js.map